import cookie from "react-cookies";

let track = function () {};
//
if (window.track) {
  track = window.track({
    url: "/pc_api/VlecTrackApi/Track",
    tokenName: "Authorization",
    getTokenFunc: function () {
      const token = cookie.load("vlec_token");
      return token;
    },
    callback: function (res) {
      //console.log(res);
    },
  });
}
export default track;



// WEBPACK FOOTER //
// ./src/Track/index.js